import variables from "Styles/variables.scss";
import jwt_decode from "jwt-decode";

import Compressor from "compressorjs";
import moment from "moment";

export const getDesignTokens = (mode) => ({
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          // Some CSS
          //   backgroundImage: "none",
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {},
        colorError: {
          backgroundColor: variables.colorRedLight
        },
        colorWarning: {
          backgroundColor: variables.lightGreyOver
        }
      }
    }
  },
  typography: {
    button: {
      textTransform: "none",
      fontSize: "0.75rem",
      fontWeight: variables.fontWeight500,
      fontFamily: variables.fontFamily
    },
    h3: {
      fontWeight: variables.fontWeight500,
      fontSize: variables.headingFontSize
    },
    fontFamily: variables.fontFamily,
    fontSize: 8.75
  },
  palette: {
    mode,
    ...(mode === "light"
      ? {
          // palette values for light mode
          // // primary: amber,
          divider: variables.grayColor,

          // text: {
          //   primary: grey[900],
          //   secondary: grey[800],
          // },
          background: {
            default: variables.lightBackground,
            paper: variables.lightBackground
          },
          success: {
            main: variables.colorGreen
          },
          error: {
            main: variables.colorRed
          },
          secondary: {
            main: variables.colorBlue
          }
        }
      : {
          background: {
            default: variables.darkBackground,
            paper: variables.darkBackground
          },
          success: {
            main: variables.colorGreen
          },
          error: {
            main: variables.colorRed
          },
          secondary: {
            main: variables.colorBlue
          },
          // palette values for dark mode
          // primary: deepOrange,
          divider: variables.grayColor,
          // background: {
          //   default: deepOrange[900],
          //   paper: deepOrange[900],
          // },
          // text: {
          //   primary: '#fff',
          //   secondary: grey[500],
          // },
          text: {
            grey: variables.tableHeadColor
          }
        })
  }
});

/**
 * Returns the number rounded to the nearest interval.
 * Example:
 *
 *   roundToNearest(1000.5, 1); // 1000
 *   roundToNearest(1000.5, 0.5);  // 1000.5
 *
 * @param {number} value    The number to round
 * @param {number} interval The numeric interval to round to
 * @return {number}
 */
export const roundToNearest = (value, interval) => {
  return Math.floor(value / interval) * interval;
};

/**
 * Groups price levels by their price
 * Example:
 *
 *  groupByPrice([ [1000, 100], [1000, 200], [993, 20] ]) // [ [ 1000, 300 ], [ 993, 20 ] ]
 *
 * @param levels
 */
export const groupByPrice = (levels) => {
  return levels
    .map((level, idx) => {
      const nextLevel = levels[idx + 1];
      const prevLevel = levels[idx - 1];

      if (nextLevel && level[0] === nextLevel[0]) {
        return [level[0], level[1] + nextLevel[1]];
      } else if (prevLevel && level[0] === prevLevel[0]) {
        return [];
      } else {
        return level;
      }
    })
    .filter((level) => level.length > 0);
};

/**
 * Group price levels by given ticket size. Uses groupByPrice() and roundToNearest()
 * Example:
 *
 * groupByTicketSize([ [1000.5, 100], [1000, 200], [993, 20] ], 1) // [[1000, 300], [993, 20]]
 *
 * @param levels
 * @param ticketSize
 */
export const groupByTicketSize = (levels, ticketSize) => {
  return groupByPrice(levels.map((level) => [roundToNearest(level[0], ticketSize), level[1]]));
};

export const formatNumber = (arg) => {
  return new Intl.NumberFormat("en-US").format(arg);
};

// Get current Date String
export const currentDateTimeFormat = () => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
  const day = currentDate.getDate().toString().padStart(2, "0");
  const hours = currentDate.getHours().toString().padStart(2, "0");
  const minutes = currentDate.getMinutes().toString().padStart(2, "0");
  const seconds = currentDate.getSeconds().toString().padStart(2, "0");
  const milliseconds = currentDate.getMilliseconds().toString().padStart(3, "0");

  const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
  return formattedDateTime;
};

/**
 * Validates token expiration
 * @param {*} token
 * @returns Boolean
 */
export const isTokenValidate = (token) => {
  try {
    const { exp: expirationTime } = jwt_decode(token);
    const currentTime = Math.floor(Date.now() / 1000);
    return expirationTime > currentTime;
  } catch (error) {
    // Handle error, token is not valid
    return false;
  }
};

/**
 * User details extraction from token
 * @param {*} token
 * @returns Object {}
 */
export const extractTokenDetails = (token) => {
  try {
    const userDetails = jwt_decode(token);
    return userDetails;
  } catch (error) {
    // Handle error, token is not valid
    return false;
  }
};

// Get get Date String from TimeStamp
export const getDateFromTimestamp = (date) => {
  const currentDate = new Date(date);
  const year = currentDate.getUTCFullYear();
  const month = (currentDate.getUTCMonth() + 1).toString().padStart(2, "0");
  const day = currentDate.getUTCDate().toString().padStart(2, "0");
  const hours = currentDate.getHours().toString().padStart(2, "0");
  const minutes = currentDate.getMinutes().toString().padStart(2, "0");
  const seconds = currentDate.getUTCSeconds().toString().padStart(2, "0");
  const milliseconds = currentDate.getUTCMilliseconds().toString().padStart(3, "0");

  const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
  return formattedDateTime;
};

// common time format
export const getCommonDateTimeFormat = (date, format = "DD/MM/YYYY") => {

  return moment(date).format(format);
};

// utc time
export const getUTCDateTimeFormat = (date) => {
  return moment(date, "DD/MM/YYYY").utc().format("DD/MM/YYYY");
};

export const checkDataIsImage = (value) => {
  return value instanceof Image;
};

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
};

//This method used for calculate image Height and Width
const calculateImageHeightWidth = (file) => {
  return new Promise((resolve, reject) => {
    try {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.onload = () => {
          let maxWidth = process.env.REACT_APP_MAX_WIDTH || 1024; //1280; // 1024
          let maxHeight = process.env.REACT_APP_MAX_HEIGHT || 520; //720; //520
          let width = img.width;
          let height = img.height;

          if (width > height) {
            if (width > maxWidth) {
              height = Math.round((height * maxWidth) / width);
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width = Math.round((width * maxHeight) / height);
              height = maxHeight;
            }
          }
          resolve({ width, height });
        };
        img.onerror = function () {
          reject(false);
        };
        img.src = event.target.result;
      };
      reader.readAsDataURL(file);
    } catch (error) {
      reject(false);
    }
  });
};

// This is method used to call compress image function
export const imageCompress = async (file) => {
  try {
    const prevsize = file.size;

    if (prevsize / 1024 < 130 || file.type == "application/pdf") {
      const fileName = `${Date.now()}.${file.type.split("/").pop()}`;
      const renamedFile = new File([file], fileName, { type: file.type });
      // file.name = renamedFile;
      return renamedFile;
    } else {
      const imgHW = await calculateImageHeightWidth(file);
      const compressFile = await imageCompressFn(file, 0.7, prevsize, imgHW);
      return compressFile;
    }
  } catch (error) {
    return false;
  }
};

// This is method used to compress image till the size gets achived
const imageCompressFn = async (file, quality, prevsize, imgHW) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      const compressedFile = await new Promise((resolve, reject) => {
        const compressor = new Compressor(file, {
          quality: quality,
          maxWidth: imgHW.width,
          maxHeight: imgHW.height,
          // // resize: "contain",
          // // mimeType: "auto",
          convertSize: 150,
          success(result) {
            if (result.size > 150 * 1024 && quality > 0.1 && prevsize != result.size) {
              // Recursively compress with a lower quality
              let qtly = quality > 0.2 ? quality - 0.1 : quality;
              qtly = parseFloat(qtly.toFixed(1));
              resolve(imageCompressFn(file, qtly, result.size, imgHW));
              compressor.abort();
            } else {
              const fileName = `${Date.now()}.${result.type.split("/").pop()}`;
              const renamedFile = new File([result], fileName, { type: result.type });
              resolve(renamedFile);
              compressor.abort();
            }
          },
          error(err) {
            compressor.abort();
            reject(err.message);
          }
        });
      });

      resolve(compressedFile);
    } catch (error) {
      reject(error);
    }
  });
};


export const TextTruncate = (str, num, dot) => {
  try {
      if (str && str.length > num) {
          if (dot) {
              return str.substring(0, num) + '...';
          } else {
              return str.substring(0, num);
          }
      } else {
          return str;
      }
  } catch (error) { }
};

export const checkPDFExtension = (filename) => {
  return /\.(pdf)$/i.test(filename);
}
